export type TTranslationKeys =
  | "continue"
  | "scanInstructions"
  | "scan"
  | "done"
  | "postOpVisualization"
  | "theProcedureIsCurrenlyNotSupportedByAI"
  | "adjustTheImplantSize"
  | "adjustTheAmountOfLift"
  | "adjustBBLAmount"
  | "adjustTheResult"
  | "visualizationCommingSoon"
  | "continueToMyQuote"
  | "instantVisualizationAndMore"
  | "instantVisualization"
  | "wellEmailYourVisualizationToYouInTheNext12Hours"
  | "tryAProcedureWithInstantVisualization"
  | "instantBeforeAfter"
  | "soundOn";

const translate: Record<TTranslationKeys, { en: string; es: string }> = {
  continue: {
    en: "Continue",
    es: "Continuar",
  },
  scanInstructions: {
    en: "Scan Instructions",
    es: "Instrucciones de escaneo",
  },
  scan: {
    en: "Scan",
    es: "Escanear",
  },
  done: {
    en: "Done",
    es: "Hecho",
  },
  postOpVisualization: {
    en: "Post-op Visualization",
    es: "Visualización postoperatoria",
  },
  theProcedureIsCurrenlyNotSupportedByAI: {
    en: "The procedure is currently not supported by AI",
    es: "El procedimiento actualmente no es compatible con la IA",
  },
  adjustTheImplantSize: {
    en: "Adjust the implant size",
    es: "Ajusta el tamaño del implante",
  },
  adjustTheAmountOfLift: {
    en: "Adjust amount of lift",
    es: "Ajusta la cantidad de levantamiento",
  },
  adjustBBLAmount: {
    en: "Adjust BBL amount",
    es: "Ajusta la cantidad de BBL",
  },
  adjustTheResult: {
    en: "Adjust the result",
    es: "Ajusta el resultado",
  },
  visualizationCommingSoon: {
    en: "Visualization coming soon!",
    es: "¡Visualización próximamente!",
  },
  continueToMyQuote: {
    en: "Continue to my quote",
    es: "Continuar con mi cotización",
  },
  instantVisualizationAndMore: {
    en: "Instant visualizations for this procedure are coming soon. We’ll email your visualization to you in the next 12 hours.",
    es: "Las visualizaciones instantáneas para este procedimiento están próximamente. Te enviaremos tu visualización por correo electrónico en las próximas 12 horas.",
  },
  instantVisualization: {
    en: "Instant visualizations for this procedure are coming soon.",
    es: "Las visualizaciones instantáneas para este procedimiento están próximamente.",
  },
  wellEmailYourVisualizationToYouInTheNext12Hours: {
    en: "We’ll email your visualization to you in the next 12 hours.",
    es: "Te enviaremos tu visualización por correo electrónico en las próximas 12 horas.",
  },
  tryAProcedureWithInstantVisualization: {
    en: "Try a procedure with instant visualization",
    es: "Prueba un procedimiento con visualización instantánea",
  },
  instantBeforeAfter: {
    en: "Instant Before / After",
    es: "Antes / Después instantáneo",
  },
  soundOn: {
    en: "Sound On",
    es: "Sonido activado",
  },
};

export function getTranslation(
  key: TTranslationKeys,
  lang: "en" | "es",
): string {
  return translate[key][lang];
}
